<div class="db-env-switcher mt10 mb12" (click)="toggleEnvSwitcher()">
  <div>
    <span class="db-website-item-menu__checkmark-container mr8">
      <img class="db-env-switch-img"
           [src]="'assets/images/menu-icons/' + (currentEnv === 'live' ? 'live' : 'staging') + '.svg'"
           alt=""/>
    </span>
    <p>{{(currentEnv === 'live' ? 'text_live_environment' : 'text_stagingEnvironment') | dbText}}</p>
  </div>
  <i class="dropdown db-icon db-icon-ds-arrow-sharp" [ngClass]="{'rotate': toggled}"></i>
</div>

<div class="db-env-switcher__separator"></div>

<div *ngIf="toggled" class="db-env-switcher__dropdown">
  <div class="db-env-switcher__dropdown-item mb15" (click)="changeEnvironment('live')">
    <h4>{{'text_live_environment' | dbText}}</h4>
    <p>{{'text_liveChangesDesc' | dbText}}</p>
  </div>
  <div class="db-env-switcher__dropdown-staging">
    <div class="db-env-switcher__dropdown-item" (click)="changeEnvironment('staging')">
      <h4>{{'text_stagingEnvironment' | dbText}}</h4>
      <p>{{'text_test_settings_staging_env' | dbText}}</p>
    </div>
    <div *ngIf="stagingEnabled || currentEnv === 'staging'" class="db-env-switcher__dropdown-separator"></div>
    <div *ngIf="stagingEnabled || currentEnv === 'staging'" class="db-env-switcher__dropdown-settings"
         (click)="redirectToManageEnv()">
      <i class="db-icon db-icon-ds-settings"></i>
    </div>
  </div>
</div>
